module.exports = __webpack_public_path__ + "img/309.f4366e10.png";